angular.module('gym.setup').controller('SetupCtrl', ["$scope", "$window", "$state", "$timeout", "loadingAnimation", "flash", "GymSetupService", "UnitsService", "GTMService", "currentUser", "gymSetup", function($scope, $window, $state, $timeout, loadingAnimation, flash, GymSetupService, UnitsService, GTMService, currentUser, gymSetup) {
  var getTimezone, units;
  angular.element('.app-main').addClass('app-main--setup');
  $scope.currentUser = currentUser;
  $scope.gymSetup = gymSetup;
  $scope.gymSetup.fields_template = 'Gym';
  $scope.errors = {
    phone_number: ["This field is required"]
  };
  units = UnitsService.get();
  GTMService.push({
    event_action: 'Trial Signup',
    event_category: 'Lifecycle Event',
    event: 'custom_event'
  });
  GTMService.push({
    event: 'start_my_free_trial_step2'
  });
  GTMService.trackPage('Trial Signup Setup');
  getTimezone = function() {
    var browserTz, country, includesBrowserTz;
    country = $scope.gymSetup.country;
    browserTz = window.Intl.DateTimeFormat().resolvedOptions().timeZone;
    includesBrowserTz = _.find(gymSetup.country_timezones_data[country].timezones, function(tz) {
      return tz.id === browserTz;
    });
    return $scope.gymSetup.tz = (function() {
      switch (false) {
        case gymSetup.country_timezones_data[country].timezones.length !== 1:
          return gymSetup.country_timezones_data[country].timezones[0].id;
        case !includesBrowserTz:
          return browserTz;
        default:
          return void 0;
      }
    })();
  };
  getTimezone();
  $window.onbeforeunload = function(e) {
    var dialogText;
    dialogText = 'Are you sure you want to leave this page? Please complete this form to finish setting up your account.';
    e.returnValue = dialogText;
    return dialogText;
  };
  $scope.onCountryChanged = function() {
    var country;
    country = $scope.gymSetup.country;
    $scope.gymSetup.currency = units[country].currency;
    $scope.gymSetup.mass = units[country].mass;
    $scope.gymSetup.measurement = units[country].measurement;
    $scope.gymSetup.street_address_country = country;
    return getTimezone();
  };
  $scope.isFormValid = function() {
    return $scope.gymSetup.tz;
  };
  $scope.onFieldChange = function(field) {
    return $scope.errors[field] = $scope.gymSetup[field] ? void 0 : ["This field is required"];
  };
  return $scope.save = function() {
    if (_.find($scope.errors, function(error) {
      return error;
    })) {
      return;
    }
    loadingAnimation.show();
    $scope.gymSetup.copy_to_website = '1';
    return GymSetupService.set($scope.gymSetup).then(function(data) {
      $window.onbeforeunload = void 0;
      GTMService.push({
        event: 'start_my_free_trial_step3'
      });
      return $timeout(function() {
        return $window.location = $state.href('gym.dashboard');
      }, 500);
    }, function() {
      loadingAnimation.hide();
      return flash.error = "Request could not be completed. Please try again";
    });
  };
}]);
